





















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import "../BudgetView.scss";
import { Ax } from "@/utils";
import JournalTable from "@/modules/budget/components/Journal.vue";
import store from "@/services/store";

@Component({
    components: { JournalTable }
})
export default class PdfLoader515 extends Vue {
    @Prop({ type: Object, required: true }) propData!: null;
    @Prop({ type: [], required: true })  fileBody!: null;
    @Prop({ type: String })  fileName!: string;
    @Prop({ type: File })  file!: File;

    light: string = "light";
    fields = [
        { key: "payment_number", label: "№ платежа", sortable: false },
        { key: "payment_date", label: "Дата платежа", sortable: false },
        { key: "amount", label: "Сумма", sortable: false }, // Сумма не меняется в течение года
        { key: "notification_number", label: "№ уведомления", sortable: false }, // Не обязательное поле
        { key: "invoice_number", label: "№ счета к оплате/платежного поручения", sortable: false }, // Номер банковской транзакции
        { key: "gu_prg_ppr_code", label: "Учреждение/БП/БПП/СПФ", sortable: false },
        { key: "iin_bin", label: "ИИН/БИН", sortable: false }, // Данные по получателю
        { key: "name", label: "Наименование", sortable: false },
        { key: "bik", label: "БИК банка", sortable: false },
        { key: "iik", label: "ИИК счета", sortable: false },
    ];


    get userLogin(): string {
        return this.$store.state.user.login;
    }

    async CheckHash(): Promise<void> {
        if (!this.file || !this.fileName) return;

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        try {
            const response = await fetch("/api-py/check-hash", {
                method: "POST",
                body: formData
            });

            const result = await response.json();
            console.debug(result);

            if (result === true) {
                this.handleOk();
            } else {
                this.on515Load(formData);
            }
        } catch (error) {
            console.error("Error checking hash:", error);
        }
    }

    handleOk(): void {
        if (!this.file || !this.fileName) return;

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        this.$bvModal
            .msgBoxConfirm("Сохранение приведет к изменению ранее принятых данных", {
                title: "Подтвердите",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "Сохранить",
                cancelTitle: "Отменить",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then((value: boolean) => {
                console.log("Save", value);
                if (value) {
                    this.on515Load(formData);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    on515Load(formData: FormData): void {
        const user = this.userLogin;
        this.$emit("save-load515", true);

        Ax({
            url: `/api-py/save-b515/${user}`,
            method: "POST",
            data: formData
        }, data => {
            console.debug("Data", data)
        });

        this.makeToast("success", "Загрузка файла начата! Результат в журнале Загрузки", "Результат");
        this.$emit("save-load515", false);
    }

    onClear(): void {
        this.$emit("form-clear515", []);
        if (this.propData) {
            this.propData = null
        }
    }

    makeToast(variant: string, tostbody: string, title: string): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: 2000,
            solid: true
        });
    }

    keyEvent(event: KeyboardEvent): void {
        // Обработчик событий клавиатуры (пока пуст)
    }
}

